// 仓库
export default [
  //废弃商品申请
  {
    path: '/abandonedGoods',
    name: 'abandonedGoods',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/abandonedGoods'),
    meta: {
      activeMenu: 'abandonedGoods', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //区域设置
  {
    path: '/areaSettings',
    name: 'areaSettings',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/areaSettings'),
    meta: {
      activeMenu: 'areaSettings', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //清理商品
  {
    path: '/cleanUpGoods',
    name: 'cleanUpGoods',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/cleanUpGoods'),
    meta: {
      activeMenu: 'cleanUpGoods', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //库存详情
  {
    path: '/inventoryDetails',
    name: 'inventoryDetails',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/inventoryDetails'),
    meta: {
      activeMenu: 'inventoryDetails', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //货架管理
  {
    path: '/warehouseLocationManagement',
    name: 'warehouseLocationManagement',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/warehouseLocationManagement'),
    meta: {
      activeMenu: 'warehouseLocationManagement', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //库位管理
  {
    path: '/storageLocationManagement',
    name: 'storageLocationManagement',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/storageLocationManagement'),
    meta: {
      activeMenu: 'storageLocationManagement', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //辅料列表
  {
    path: '/material',
    name: 'material',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/material'),
    meta: {
      activeMenu: 'material', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //普通仓库
  {
    path: '/regularWarehouse',
    name: 'regularWarehouse',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/regularWarehouse'),
    meta: {
      activeMenu: 'regularWarehouse', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //备品仓库
  {
    path: '/sparePartsWarehouse',
    name: 'sparePartsWarehouse',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/sparePartsWarehouse'),
    meta: {
      activeMenu: 'sparePartsWarehouse', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //长存仓库
  {
    path: '/longTermStorageWarehouse',
    name: 'longTermStorageWarehouse',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/longTermStorageWarehouse'),
    meta: {
      activeMenu: 'longTermStorageWarehouse', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //仓储费配置
  {
    path: '/warehouseFeeConfiguration',
    name: 'warehouseFeeConfiguration',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/costManagement/warehouseFeeConfiguration'),
    meta: {
      activeMenu: 'warehouseFeeConfiguration', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //常规仓储费
  {
    path: '/regularStorageFee',
    name: 'regularStorageFee',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/costManagement/regularStorageFee'),
    meta: {
      activeMenu: 'regularStorageFee', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //仓储费账单
  {
    path: '/warehouseFeeBill',
    name: 'warehouseFeeBill',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/costManagement/warehouseFeeBill'),
    meta: {
      activeMenu: 'warehouseFeeBill', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //常规仓库账单
  {
    path: '/regularWarehouseBill',
    name: 'regularWarehouseBill',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/costManagement/regularWarehouseBill'),
    meta: {
      activeMenu: 'regularWarehouseBill', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  // 仓库新功能独立实验页
  {
    path: '/warehouseFeatureTest',
    name: 'warehouseFeatureTest',
    component: () => import( /* webpackChunkName: "warehouse" */ '@/views/home/warehouse/warehouseFeatureTest'),
    meta: {
      activeMenu: 'warehouseFeatureTest'
    }
  },

]
